// extracted by mini-css-extract-plugin
export var button = "_59-7";
export var buttonRow = "_59-6";
export var fadeIn = "_59-1";
export var gradient = "_59-0";
export var panel = "_59-2";
export var panelIn = "_59-3";
export var subtitle = "_59-5";
export var title = "_59-4";